import { tvShows } from '@/mocks/tv-shows';
import TvShowCard from './TvShowCard';

export default function GenreSection() {
  const guochanShows = tvShows.filter(s => s.categorySlug === 'guochan').slice(0, 4);
  const hanjuShows = tvShows.filter(s => s.categorySlug === 'hanju').slice(0, 4);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            <i className="ri-flag-2-line text-primary-500 mr-2"></i>
            国产剧精选
          </h2>
          <p className="text-sm text-foreground-500 mt-1">精选优质国产好剧，总有一部适合你</p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {guochanShows.map((show) => (
          <TvShowCard key={show.id} show={show} />
        ))}
      </div>
    </section>
  );
}

export function HanjuSection() {
  const hanjuShows = tvShows.filter(s => s.categorySlug === 'hanju').slice(0, 4);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            <i className="ri-kakao-talk-line text-accent-500 mr-2"></i>
            韩剧精选
          </h2>
          <p className="text-sm text-foreground-500 mt-1">口碑韩剧一网打尽，追剧停不下来</p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {hanjuShows.map((show) => (
          <TvShowCard key={show.id} show={show} />
        ))}
      </div>
    </section>
  );
}